import {Injectable} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Country, GetParams, GetResponse, Location, LocationCreate, PostResponse, TransportType} from '@app/shared';
import {Observable} from 'rxjs';
import {convertGetParamsToHttpParams} from '@app/core';

@Injectable({
  providedIn: 'root',
})
export class LocationTransportService {
  /** URLs principales relacionadas con Locations y Transports **/
  countryUrl = environment.coreApiBaseUrl + '/api/country';
  locationTypeUrl = environment.coreApiBaseUrl + '/api/locationType';
  locationUrl = environment.coreApiBaseUrl + '/api/location';
  transportTypeUrl = environment.coreApiBaseUrl + '/api/transport-type';

  constructor(private http: HttpClient) {
  }

  /** Metodos de obtener/crear/actualizar/eliminar Country **/
  getCountry(getParams: GetParams): Observable<GetResponse> {
    return this.http
      .get<GetResponse>(this.countryUrl, {
        params: convertGetParamsToHttpParams(getParams),
      })
  }

  createCountry(newCountry: {
    code: string;
    name: string;
  }): Observable<PostResponse> {
    return this.http
      .post<PostResponse>(this.countryUrl, newCountry)
  }

  updateCountry(country: Country): Observable<any> {
    return this.http.put<PostResponse>(this.countryUrl, country)
  }

  deleteCountry(countryIds: number[]): Observable<any> {
    return this.http
      .delete<PostResponse>(this.countryUrl, {body: {ids: countryIds}})
  }

  /** Metodos de obtener/crear/actualizar/eliminar LocationType **/
  getLocationType(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.locationTypeUrl, {
      params: convertGetParamsToHttpParams(getParams),
    })
  }

  createLocationType(
    newLocationType: FormData
  ): Observable<HttpEvent<PostResponse>> {
    const headers = new HttpHeaders({enctype: 'multipart/form-data'});
    return this.http.post<PostResponse>(this.locationTypeUrl, newLocationType, {
      headers,
      reportProgress: true,
      observe: 'events',
    })
  }

  updateLocationType(
    locationType: FormData
  ): Observable<HttpEvent<PostResponse>> {
    const headers = new HttpHeaders({enctype: 'multipart/form-data'});
    return this.http.put<PostResponse>(this.locationTypeUrl, locationType, {
      headers,
      reportProgress: true,
      observe: 'events',
    })
  }

  deleteLocationType(ids: number[]): Observable<any> {
    return this.http.delete<PostResponse>(this.locationTypeUrl, {
      body: {ids: ids},
    })
  }

  /** Metodos de obtener/crear/actualizar/eliminar Location **/
  getLocation(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.locationUrl, {
      params: convertGetParamsToHttpParams(getParams),
    });
  }

  createLocation(newLocation: LocationCreate): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.locationUrl, newLocation);
  }

  updateLocation(location: Location): Observable<any> {
    return this.http.put(this.locationUrl, location);
  }

  deleteLocation(locationsIds: number[]): Observable<any> {
    return this.http.delete(this.locationUrl, {body: {ids: locationsIds}});
  }

  /** Metodos de obtener/crear/actualizar/eliminar Location **/
  getTransportType(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.transportTypeUrl, {
      params: convertGetParamsToHttpParams(getParams),
    });
  }

  createTransportType(newTransportType: {
    name: string;
    isActive: boolean;
  }): Observable<PostResponse> {
    return this.http.post<PostResponse>(
      this.transportTypeUrl,
      newTransportType
    );
  }

  updateTransportType(transportType: TransportType): Observable<any> {
    return this.http.put(this.transportTypeUrl, transportType);
  }

  deleteTransportType(transportTypesIds: number[]): Observable<any> {
    return this.http.delete(this.transportTypeUrl, {
      body: {ids: transportTypesIds},
    });
  }
}
